import { render, staticRenderFns } from "./moreRecord.vue?vue&type=template&id=882d09e0&scoped=true"
import script from "./moreRecord.vue?vue&type=script&lang=js"
export * from "./moreRecord.vue?vue&type=script&lang=js"
import style0 from "./moreRecord.vue?vue&type=style&index=0&id=882d09e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d09e0",
  null
  
)

export default component.exports